import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';

import { WebBridgeService } from './web-bridge.service';

export const provideWebBridge = () => runOnSportsWebInit(WebBridgeService);
